import {Component, EventEmitter, Injector, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FilterType} from "../../../enums/filter.type";
import {BaseComponent} from "../../base.component";
import {ListResponse} from "../../../network/service/list.response";
import {SnackBarUtil} from "../../../util/snack.bar.util";

@Component({
  selector: 'app-frontend-filter',
  standalone: false,
  templateUrl: './frontend-filter.component.html',
  styleUrls: ['./frontend-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FrontendFilterComponent extends BaseComponent implements OnInit {
  FilterType = FilterType;
  isMinimized = true;
  minimizedCount = 6;
  dataSource: any = [];
  displayColumnTypes: string[] = [];
  displayColumns: string[] = [];
  displayDataSources: string[] = [];
  microservice?: string;
  protocolMethod?: string;
  version?: string;
  controller?: string;
  method?: string;
  @Input()
  class?: string;
  @Input()
  filters: any = [];
  @Input()
  lookupName?: string;
  @Output()
  onFiltersChanged: EventEmitter<any> = new EventEmitter();
  @Output()
  onLookUpSelected: EventEmitter<any> = new EventEmitter();

  constructor(injector: Injector) {
    super(injector);
    if (screen.width <= 768) {
      this.minimizedCount = 3;
    }
    // this.hotkeysService.add(new Hotkey('alt+shift+s', (event: KeyboardEvent): boolean => {
    //   this.onSearchClicked();
    //   return false;
    // }));
    // this.hotkeysService.add(new Hotkey('alt+shift+r', (event: KeyboardEvent): boolean => {
    //   this.onResetClicked();
    //   return false;
    // }));
  }

  override ngOnInit() {
    super.ngOnInit();
    if (this.lookupName) {
      let lookup: any;
      switch (this.lookupName) {
        default:
          lookup = {};
      }
      this.displayColumnTypes = lookup.displayColumnTypes;
      this.displayColumns = lookup.displayColumns;
      this.displayDataSources = lookup.displayDataSources;
      if (!lookup.displayColumns.includes('Choose')) {
        this.displayColumnTypes.splice(0, 0, 'event');
        this.displayColumns.splice(0, 0, 'Choose');
        this.displayDataSources.splice(0, 0, 'touch_app');
      }
      this.displayColumnTypes = lookup.displayColumnTypes;
      this.displayColumns = lookup.displayColumns;
      this.displayDataSources = lookup.displayDataSources;
      this.protocolMethod = lookup.protocolMethod;
      this.microservice = lookup.microservice;
      this.version = lookup.version;
      this.controller = lookup.controller;
      this.method = lookup.method;
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.onQueryChanged();
  }

  onQueryChanged(filters?: any) {
    if (this.protocolMethod === 'POST') {
      this.serviceApi.postSelect(this.microservice!, this.version!, this.controller!, this.method!, {
        Filter: filters,
        Order: this.tableProperties.order ?? {
          Field: 'ModifyDate',
          Type: 'DESC'
        }
      }, this.tableProperties.offset, this.tableProperties.limit).subscribe((res: ListResponse<any>) => {
        this.dataSource = res.data ?? [];
        this.tableProperties.pageLength = res.count!;
        this.setListeners();
      });
    }
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.onQueryChanged();
  }

  onSearchClicked() {
    if (this.filters.some((filter: any) => {
      return filter.Value === undefined && filter.Required;
    })) {
      SnackBarUtil.makeMessage(this, this.translateService.instant('FillRequiredFields'), false);
      return;
    }
    let temp = this.filters.filter((filter: any) => {
      return filter.Value !== undefined;
    });
    let values: any = [];
    for (let i = 0; i < temp.length; i++) {
      switch (temp[i].Type) {
        case 'CHECK_BOX':
        case 'DATE':
        case 'SELECT':
        case 'DROP_DOWN':
        case 'TIME':
        case 'NUMBER':
          if (temp[i].Value !== undefined) {
            values.push({
              Field: temp[i].Field,
              Type: 'EQ',
              Value: temp[i].Value
            });
          }
          break;
        case 'STRING':
          if (temp[i].Value !== undefined) {
            values.push({
              Field: temp[i].Field,
              Type: 'LIKE',
              Value: '%' + temp[i].Value + '%'
            });
          }
          break;
      }
    }
    let body = {
      Type: 'AND',
      Values: values
    };
    if (!this.lookupName) {
      this.onFiltersChanged.emit(body);
    } else {
      this.tableProperties.offset = 0;
      this.onQueryChanged(body);
    }
  }

  onResetClicked() {
    let body = {
      Type: 'AND',
      Values: []
    };
    this.filters.forEach((filter: any) => {
      filter.Value = undefined;
      if (filter.Type === FilterType.SELECT || filter.Type === FilterType.DROP_DOWN) {
        filter.SelectedOptions = [];
      }
    });
    if (this.lookupName) {
      this.tableProperties.offset = 0;
      this.onQueryChanged();
    } else {
      this.onFiltersChanged.emit(body);
    }
  }

  onItemSelected(index: number, value?: any) {
    if (this.filters[index].IsMultiple) {
      let temp: any = [];
      for (let i = 0; i < value.length; i++) {
        let tempValue = value[i];
        for (let j = 0; j < this.filters[index].ValueId.split('.').length; j++) {
          if (tempValue) {
            tempValue = tempValue[this.filters[index].ValueId.split('.')[j]];
          }
        }
        temp.push(tempValue);
      }
      this.filters[index].Value = temp;
    } else {
      for (let i = 0; i < this.filters[index].ValueId.split('.').length; i++) {
        if (value) {
          value = value[this.filters[index].ValueId.split('.')[i]];
        }
      }
      this.filters[index].Value = value;
    }
    if (this.filters[index].AutoSelectLatest) {
      this.onSearchClicked();
    }
  }

  override setListeners() {
    for (let i = 0; i < this.dataSource.length; i++) {
      this.dataSource[i].touch_app = (index: number) => {
        this.onLookUpSelected.emit(this.dataSource[index]);
      };
    }
  }
}
